module.exports = __webpack_public_path__ + "img/galeria-captores-10.ed7eac8d.png";